// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"297":"1b1fe7b4de394145","405":"52f169bb5720725f"}[chunkId] + ".css";
};